import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { field } from "../../types";
export function SortableFieldRow({
  field,
  children
}: {
  field: field;
  children: React.ReactNode;
}){
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: field.field_key });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };
    return (
        <div ref = {setNodeRef} style = {style} {...attributes}>
            <div className = "d-flex gap-2">
                <div className = "d-flex align-items-center px-2">
                <span
                    {...listeners}
                    className = "cursor-grab px-2 text-muted"
                    style = {{ userSelect: "none" }}
                >
                    ☰
                </span>
                </div>
                <div className = "flex-grow-1">{children}</div>
            </div>
        </div>
    );
}
